module.exports = __webpack_public_path__ + "static/media/bonusSpins_1000.da839e28.png";